import React, { Component } from 'react'
import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon  } from 'mdbreact';
import Axios from 'axios'

import adminfaculty from '../adminfaculty/adminfaculty';
import Modalarticletyps from './Modalarticletypes';




export default class superadmin extends Component {

    constructor(props) {
        super(props);
        this.state = {
            article:[]
        };
        // this.handleChange = this.handleChange.bind(this);
        // this.handleChange2 = this.handleChange2.bind(this);
         this.updateat = this.updateat.bind(this);
      }


    componentDidMount() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
    
        }

        setTimeout(() => {
           
            Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticle.php')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ article: res.data})
           }) 
         }, 0);

      }


      updateat(){
        setTimeout(() => {
           
          Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticle.php')
         .then(res => {
           console.log(res);
         //  this.setState({ bankname: res.data, loading: false })
           this.setState({ article: res.data})
         }) 
       }, 0);
      }



    render() {
        return (
            <MDBContainer>
            <div>
        
            <p className="text-right">สวัสดีคุณ : {localStorage.getItem('nameuser')} (ผู้ดูแลระบบกลาง)</p>
            <p className="text-right">การประชุมวิชาการระดับชาติ สำหรับนักศึกษา ครั้งที่ 1 สถาบันวิจัยและพัฒนา มหาวิทยาลัยราชภัฏกำแพงเพชร</p> 
         
               <MDBAlert color="success" >
                   <h2> <MDBIcon far icon="file-alt" /> บทความเข้าใหม่</h2>
                </MDBAlert>
                <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>ผู้เขียน</th>
                        <th>สาขา</th>
                        <th>ไฟล์บทความ</th>
                        <th>จัดการ</th>
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.article.map((article,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{article.send_name}</td>
                        <td>{article.namepresent}</td>
                        <td>{article.major_precent}</td>
                        <td><MDBBtn color="indigo" size="sm" href={article.send_uploadeword1}  target="_blank">WORD</MDBBtn> <MDBBtn color="pink" size="sm" href={article.send_uploadepdf1}  target="_blank">PDF</MDBBtn></td>
                        <td>   <Modalarticletyps  id_send={article.id_send} namearticla={article.send_name}  updateat={this.updateat} /></td>
                        </tr>
                      )}
                    </MDBTableBody>
                    </MDBTable>

            </div>
            </MDBContainer>
        )
    }
}
